import { MouseEvent, KeyboardEvent, useState } from "react";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { SIZE_M, SIZE_S, SIZE_L } from "../../constants";
import { ButtonLink } from "../button";
import Video from "../video";
import Cards from "./cards";
import Heads from "./heads";
import FiberImage, { ImageRequireType } from "../image";
import { Play } from "../icons";
import { showBanner } from "../cookieBanner";
import { logEvent, getAnalyticsEnabled } from "../../utils";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1d9l9oy"
});
const MiddleSection = /*#__PURE__*/styled("div")({
  name: "MiddleSection",
  class: "mhy6t85"
});
const Header = /*#__PURE__*/styled("h1")({
  name: "Header",
  class: "hamcjlc"
});
const ImageContainer = /*#__PURE__*/styled("div")({
  name: "ImageContainer",
  class: "ickl448"
});
const BottomSection = /*#__PURE__*/styled("div")({
  name: "BottomSection",
  class: "b13a6s5g"
});
const screenshotClassName = "s1l5ceu3";
const PlayContainer = /*#__PURE__*/styled("div")({
  name: "PlayContainer",
  class: "pm5rhus"
});
const screenshot = (require("./screenshot.png?resize&format=png&placeholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

function alertCookie() {
  showBanner();
}

function handleSignUpClick(event: MouseEvent<HTMLElement>) {
  event.preventDefault();

  if (getAnalyticsEnabled()) {
    logEvent("button:click", "early-access", "homepage");
    const url = event.currentTarget.getAttribute("href");
    url && setTimeout(() => document.location.href = url, 100);
    return;
  }

  alertCookie();
}

function handleKeyDown(event: KeyboardEvent<HTMLElement>) {
  if (getAnalyticsEnabled()) {
    return;
  }

  if (event.key === "Enter" || event.key === " ") {
    alertCookie();
  }
}

export default function Homepage(): JSX.Element {
  const [videoVisible, setVideoVisible] = useState(false);
  return <Container>
      {videoVisible && <Video hide={() => {
      setVideoVisible(false);
      logEvent("close", "video", "homepage");
    }} />}
      <MiddleSection>
        <Header>
          Collaborative notebooks
          <br /> for debugging your infrastructure
        </Header>
        <ButtonLink buttonStyle="primary" href="https://airtable.com/shr4ZEk5YWZzQlyKk" onClick={handleSignUpClick} onKeyDown={handleKeyDown}>
          Sign up for early access
        </ButtonLink>
      </MiddleSection>
      <BottomSection>
        <Heads />
        <Cards />
        <ImageContainer>
          <FiberImage className={screenshotClassName} src={screenshot.src} width={screenshot.width} height={screenshot.height} srcSet={screenshot.srcSet} alt="Fiberplane studio example UI" />
          <PlayContainer>
            <Play onClick={() => {
            setVideoVisible(true);
            logEvent("button:click", "video", "homepage");
          }} />
          </PlayContainer>
        </ImageContainer>
      </BottomSection>
    </Container>;
}

require("../../../.linaria-cache/src/components/homepage/index.linaria.module.css");